module.exports = __webpack_public_path__ + "images/category_lp/pc/reason3_3707a7514d308f0ba052f7ca9f514003.png";